import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'pc-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent implements OnInit {
  @Input() size: 4 | 6 | 8 | 16 = 6;

  constructor() {}

  ngOnInit(): void {}

  public getWrapperClasses(): string[] {
    const classes = [];

    classes.push('size-' + this.size, 'overflow-hidden');

    return classes;
  }
}
